import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { closeCreateNewCustomerModal } from 'actions/ui';
import ConfirmModal from 'components/ConfirmModal';
import { translate } from 'react-i18next';
import { KeyCodes } from 'constants/index';
import CreateCustomerForm from './CreateCustomerForm/index';
import Popup from 'components/Styled/Modal/Popup';

const mapStateToProps = state => ({
	isOpen: state.ui.showCreateNewCustomerModal,
	modalContext: state.ui.newCustomerModalContext,
});

const mapDispatchToProps = dispatch => ({
	closeCreateNewCustomerModal: () => dispatch(closeCreateNewCustomerModal()),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
class CreateNewCustomerModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			warningPopupOpen: false,
			personForm: false,
			organization: false,
			address: false,
			juridicalAddress: false,
		};

		this.onClose = this.onClose.bind(this);

		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.enableWarning = this.enableWarning.bind(this);
	}

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyPress);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyPress);
	}

	onClose() {
		const { personForm, address, juridicalAddress, organization } = this.state;

		if ([personForm, address, juridicalAddress, organization].some(i => (i === true))) {
			this.setState({ warningPopupOpen: true });
		} else {
			this.props.closeCreateNewCustomerModal();
		}
	};

	enableWarning(warning) {
		this.setState(warning);
	};

	handleKeyPress(e) {
		if (e.keyCode === KeyCodes.ESCAPE) {
			this.onClose();
		}
	};

	handleCloseWarningPopup = () => this.setState({ warningPopupOpen: false });

	onClickDangerButton = () => {
		this.handleCloseWarningPopup();
		this.props.closeCreateNewCustomerModal();
	};

	render() {
		const { isOpen, t, modalContext } = this.props;
		return (
			<>
				<Popup
					isShow={isOpen}
					id="create-customer-common"
					title={t('appeal.newCustomer')}
					onClickClose={this.onClose}
				>
					<div data-testid="create-customer-modal">
						<CreateCustomerForm {...modalContext} enableWarning={this.enableWarning} />
					</div>
				</Popup>

				{
					this.state.warningPopupOpen && (
						<ConfirmModal
							onClose={this.handleCloseWarningPopup}
							dangerButton
							secondaryButton
							titleModal="Зверніть увагу!"
							contentModalText={t('modalWindowsLabels.notSavedWarning')}
							dangerButtonText="Закрити"
							secondaryButtonText={t('cancel')}
							onClickDangerButton={this.onClickDangerButton}
							onClickSecondaryButton={this.handleCloseWarningPopup}
						/>
					)
				}
			</>
		);
	}
}

CreateNewCustomerModal.propTypes = {
	closeCreateNewCustomerModal: PropTypes.func,
	modalContext: PropTypes.object,
	isOpen: PropTypes.bool,
};

export default CreateNewCustomerModal;
